import script from "./FileUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileUpload.vue?vue&type=script&lang=ts&setup=true"

import "./FileUpload.vue?vue&type=style&index=0&id=0c98d58e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c98d58e"]])

export default __exports__